/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { ChartComponent } from './components/chart';
import { ChartAxisComponent } from './components/chart-axis';
import { ChartLegendComponent } from './components/chart-legend/chart-legend.component';

@NgModule({
  imports: [
    CommonModule,
    BuilderSharedModule.forChild(),
  ],
  providers: [],
  declarations: [
    ChartComponent,
    ChartLegendComponent,
    ChartAxisComponent,
  ],
  exports: [
    ChartComponent,
  ],
})
export class BuilderSharedChartsModule {
}
